<template lang="pug">
.section
  .section-header
    h1 {{ $t("ui.bo_default_domain") }}
  .section-body(style="max-width:1000px;")
    .row
      .col-12
        .card.mb-0
          .card-header
            .row.col-12
              .form-group.col-3
                b-input-group(size="sm")
                  b-input-group-text(slot="prepend")
                    span {{ $t('ui.status') }}
                  b-form-select(v-model="boDefaultDomainStatus" :disabled="loading" size="sm")
                    option(value="") {{ $t('ui.all') }}
                    option(value="ACTIVE") {{ $t('ui.active') }}
                    option(value="DEACTIVATE") {{ $t('ui.inactive') }}
              .form-group.col-6.mb-1(v-if="isEditAccess")
                SubmitButton(
                  :loading="loading"
                  icon="fa fa-search"
                  :text="$t('ui.search')"
                  type="button"
                  @click="getBoDefaultDomainList()"
                  variant="primary"
                  size="sm"
                )
              .form-group.col-12(v-if="isAdmin && isEditAccess")
                b-button(v-b-modal.addBoDefaultDomain type="button" variant="info" size="sm")
                  i.fa.fa-plus
                  span.ml-1 {{ $t("ui.combine.add_bo_default_domain") }}
          .card-body
            .row
              .col-12
                .clusterize-scroll.table-responsive
                  table.table.table-sm.table-bordered.table-striped.table-hover
                    thead.thead-light
                      tr
                        th.text-center(width="3%")
                          span #
                        th(width="8%")
                          span(:title="$t('ui.domain_id')") {{ $t('ui.domain_id') }}
                        th(width="8%")
                          span(:title="$t('ui.domain_name')") {{ $t('ui.domain_name') }}
                        th.text-center(width="8%")
                          span(:title="$t('ui.status')") {{ $t('ui.status') }}
                        th.text-right(width="8%")
                          span(:title="$t('ui.created_date')") {{ $t('ui.created_date') }}
                        th.text-center(width="5%" v-if="isAdmin && isEditAccess")
                          span(:title="$t('ui.action')") {{ $t('ui.action') }}
                    tbody.clusterize-content
                      tr(v-if="boDefaultDomainList.length == 0")
                        td(colspan="7").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in boDefaultDomainList")
                        td.text-center
                          span(:title="index + 1") {{ index + 1 }}
                        td
                          span(:title="item.domain_id") {{ item.domain_id }}
                        td
                          span(:title="item.domain_name") {{ item.domain_name }}
                        td.text-center
                          span(:title="item.status") {{ item.status }}
                        td.text-right
                          span(:title="item.created_by") {{ item.created_by }}
                          br
                          span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}
                        td.actions.text-center.align-middle(v-if="isAdmin && isEditAccess")
                          span.mr-2
                            a.fa.fa-edit.btn.btn-ssm.btn-icon.btn-primary(
                              href="javascript:void(0)"
                              @click="onEdit(item)"
                              :title="$t('ui.edit')"
                              )

      addbodefaultdomain(@clicked="addBoDefaultDomain" @failed="handleFailed")
      editbodefaultdomain(ref="editbodefaultdomain" :item="editSelectedBoDefaultDomain" @clicked="afterEdit" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import addbodefaultdomain from "@/components/content/bodefaultdomain/addBoDefaultDomain.vue";
import editbodefaultdomain from "@/components/content/bodefaultdomain/editBoDefaultDomain.vue";
import SubmitButton from "@/library/SubmitButton.vue";

export default {
  components: {
    SubmitButton,
    addbodefaultdomain,
    editbodefaultdomain
  },
  data: () => ({
    loading: false,
    boDefaultDomainList: [],
    boDefaultDomainStatus: "",
    editSelectedBoDefaultDomain: null,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
  }),
  computed: {
    accountType() {
      return this.$store.getters.accountType;
    },
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_bodefaultdomain");
    }
  },
  mounted: function() {
    this.getBoDefaultDomainList();
  },
  methods: {
    getDate(dateTime) {
      if(dateTime == null) return;
      let convertDateFormat = new this.$moment(dateTime).format("YYYY-MM-DD");
      return convertDateFormat;
    },
    onEdit(e) {
      this.editSelectedBoDefaultDomain = e;
      this.$refs.editbodefaultdomain.$refs.editBoDefaultDomain.show();
    },
    afterEdit() {
      this.getBoDefaultDomainList();
      this.$helpers.showDialog(this.$t("ui.combine.edit_bo_default_domain"), this.$t("message.success"), "success");
    },
    getBoDefaultDomainList: function() {
      let url = config.getBoDefaultDomainListUrl();

      var json = {
        auth_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.loginId,
        domain_status: this.boDefaultDomainStatus,
      }

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;

              if (this.feedback.success == true) {
                this.boDefaultDomainList = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },

    addBoDefaultDomain: function() {
      this.getBoDefaultDomainList();

      this.$helpers.showDialog(this.$t("ui.combine.add_domain"), this.$t("message.success"), "success");
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>